module.exports = __webpack_public_path__ + "img/logo-black.9b39b1d0.png";